import axios from '../../config/connections'
import { AxiosResponse } from 'axios'
import {
  ExtractPermisionSubmenuFn,
  GenerateValuePermissionsFn,
  RegisterPermissionsFn,
  UserCredential,
  UserInfo,
  UserInfoOnUI,
} from './type'
import isArray from 'lodash/isArray'
import isNull from 'lodash/isNull'
import flatMap from 'lodash/flatMap'
import { PERMISSION_INFO, PERMISSION_LIST } from '../../constants'
import { RolePermission } from '../../resources/roles-permissions/type'
// const user = { data: null }

export const fetchUserInfo = async (): Promise<AxiosResponse<{ result: UserInfo }>> => {
  return await axios.get('/auth/me')
}

export const getLocalUserInfo = (): UserInfoOnUI | null => JSON.parse(localStorage.getItem('user'))

export const removeUser = (): void => localStorage.removeItem('user')

export const setUser = (payload: UserInfoOnUI | null): UserInfoOnUI => {
  const user = payload
  localStorage.setItem('user', JSON.stringify(user))
  return user
}

export const refreshUserInfo = async (): Promise<UserInfoOnUI> => {
  try {
    const response = await fetchUserInfo()
    if (response.status !== 200) throw new Error('ra.auth.auth_check_error')
    const { avatar, ...data } = response && response.data.result

    const userInfo = {
      avatar: avatar ? avatar.full_path : null,
      ...data,
    }
    return setUser(userInfo)
  } catch (error) {
    throw new Error(error.message)
  }
}

export const login = async (payload: UserCredential): Promise<AxiosResponse> => {
  return await axios.post('auth/login', payload)
}

export const logout = async (): Promise<AxiosResponse> => {
  return await axios.get('auth/logout')
}

export const generateValuePermissions: GenerateValuePermissionsFn = (
  permissionList,
  extractedPermissions,
) => {
  const registerPermissions = []
  permissionList.forEach((perm: RolePermission) => {
    const registerPermissionObj = {
      key: perm.key,
    }
    const target = extractedPermissions.find(
      (permConfigs: RolePermission) => permConfigs.key === perm.key,
    )
    PERMISSION_LIST.forEach((el) => {
      // Iterate over each permission check to check whether this feature allow this actions i.e. read_check, update_check
      const permissionCheck = PERMISSION_INFO[el].key
      const isHavePermission = PERMISSION_INFO[el].permission
      if (perm[permissionCheck]) {
        registerPermissionObj[isHavePermission] = target
          ? !isNull(target[isHavePermission])
            ? target[isHavePermission]
            : null
          : false
      }
    })
    registerPermissions.push(registerPermissionObj)
  })
  return registerPermissions
}

export const registerPermissions: RegisterPermissionsFn = (permissionList) => {
  const registerPermissions = []
  permissionList.forEach((perm: RolePermission) => {
    const registerPermissionObj = {
      key: perm.key,
    }
    PERMISSION_LIST.forEach((el) => {
      const permissionCheck = PERMISSION_INFO[el].key
      const isHavePermission = PERMISSION_INFO[el].permission
      if (perm[permissionCheck]) {
        registerPermissionObj[isHavePermission] = false
      }
    })

    registerPermissions.push(registerPermissionObj)
  })
  return registerPermissions
}

export const extractPermisionSubmenu: ExtractPermisionSubmenuFn = (permissions) => {
  return flatMap(permissions, (perm) => {
    return isArray(perm.sub_menu) && perm.sub_menu.length > 0 ? [perm, ...perm.sub_menu] : perm
  })
}
